import { css, html, LitElement } from "lit";
import { property } from "lit/decorators/property.js";

export class BeamProgressBar extends LitElement {
  @property({ type: Number }) value = 0;
  @property({ type: Boolean }) animateProgress = true;

  render() {
    return html`<div class="progress-bar-container">
      <style>
        :host {
          --beam-ProgressBar-value: ${this.value};
        }
      </style>
      <div class="progress-bar"></div>
    </div>`;
  }

  static styles = css`
    :host {
      display: inline-block;
      min-width: 20px;
    }

    .progress-bar-container {
      border-radius: var(--beam-ProgressBar-border-radius, 8px);
      height: var(--beam-ProgressBar-height, 8px);
      padding: 0;
      width: 100%;
      background: var(--beam-ProgressBar-color-background, lightgray);
      position: relative;
      border: var(--beam-ProgressBar-border-width, 1px) solid var(--beam-ProgressBar-color-border, currentColor);
      overflow: hidden;
    }

    @keyframes animate-bar {
      0% {
        width: 0;
      }

      100% {
        width: calc(var(--beam-ProgressBar-value) * 1%);
      }
    }

    .progress-bar {
      width: calc(var(--beam-ProgressBar-value, 0) * 1%);
      height: 100%;
      position: absolute;
      background: var(--beam-ProgressBar-color-bar, linear-gradient(to right, currentColor, currentColor));
      left: 0;
      bottom: 0;
      top: 0;
      background-clip: padding-box;
      animation-duration: calc(
        var(--beam-ProgressBar-animation-duration-base, 0s) + var(--beam-ProgressBar-animation-duration-variable, 0s) *
          var(--beam-ProgressBar-value) / 100
      );
      animation-iteration-count: 1;
      animation-name: animate-bar;
      animation-timing-function: linear;
      border-radius: var(--beam-ProgressBar-progress-border-radius, 8px);
    }
  `;
}

customElements.get("beam-progress-bar") || customElements.define("beam-progress-bar", BeamProgressBar);

export const progressBarConfigDefaults = {
  "--beam-ProgressBar-border-radius": "8px",
  "--beam-ProgressBar-progress-border-radius": "8px",
  "--beam-ProgressBar-height": "8px",
  "--beam-ProgressBar-color-background": "transparent",
  "--beam-ProgressBar-border-width": "1px",
  "--beam-ProgressBar-color-border": "currentColor",
  "--beam-ProgressBar-color-bar": "currentColor",
  "--beam-ProgressBar-animation-duration-base": "0s",
  "--beam-ProgressBar-animation-duration-variable": "0s",
} as const;

declare global {
  interface HTMLElementTagNameMap {
    "beam-progress-bar": BeamProgressBar;
  }
}
